// document.addEventListener("DOMContentLoaded", function () {
//   const moveBisButton = () => {
//     const bisButton = document.querySelector("#boost-sd__bis-notify-me-button");
//     const priceElement = document.querySelector(".entry-short-description");

//     if (bisButton && priceElement && priceElement.parentNode) {
//       // Only move if not already after the price element
//       if (priceElement.nextSibling !== bisButton) {
//         priceElement.insertAdjacentElement("afterend", bisButton);
//         console.log(".boost-sd__bis-notify-me-button moved after .entry-price.price");
//         bisButton.classList.add("btn","btn-primary","btn-rounded","text-uppercase","single_add_to_cart_button");
//       }
//     }
//   };

//   // Run after DOM load
//   moveBisButton();

//   // Also handle dynamically injected elements (Boost filter, AJAX, etc.)
//   const observer = new MutationObserver(moveBisButton);
//   observer.observe(document.body, { childList: true, subtree: true });
  
//   //notify me button click event


// const clickRomaniaOption = () => {
//     // Select all country option elements
//     const countryOptions = document.querySelectorAll(".boost-sd__bis-country-option");
//     const phoneInput = document.querySelector(".boost-sd__bis-phone-input");
    
//     for (const option of countryOptions) {
//       const nameEl = option.querySelector(".boost-sd__bis-country-name");
//       if (nameEl && nameEl.textContent.trim() === "Romania") {
//         option.click();
//         console.log("✅ Clicked the Romania country option");
//         return true; // stop after first match
//       }
//     }
//     return false;
//   };

//   // Run immediately after DOM load
//   if (!clickRomaniaOption()) {
//     // In case content loads later (Boost dropdown opens dynamically)
//     const clickObserver = new MutationObserver(() => {
//       const success = clickRomaniaOption();
//       if (success) clickObserver.disconnect(); // stop observing once clicked
//     });
//     clickObserver.observe(document.body, { childList: true, subtree: true });
//   }

// const updatePhoneField = () => {
//     const phoneInput = document.querySelector("#boost-sd__bis-phone-input");
//     const mailInput = document.querySelector("#boost-sd__bis-email-input");
//     const titleElement = document.querySelector("#boost-sd__bis-popup-description");
//     const emailLabel = document.querySelector("label[for='boost-sd__bis-email-input']");
//     if (phoneInput && mailInput && titleElement && emailLabel) {
//       phoneInput.setAttribute("data-country-format", "07xxXXXxxx");
//       phoneInput.setAttribute("placeholder", "07xxXXXxxx");
//       mailInput.setAttribute("placeholder", "E-mailul tău");
//       titleElement.textContent = "Completează datele tale de contact și primești notificare pe e-mail, atunci când produsul se întoarce pe stoc!";
//       emailLabel.textContent = "Adresa de E-mail";
//       console.log("✅ Updated phone input format and placeholder to 07xxXXXxxx");
//       return true;
//     }
//     return false;
//   };

//   // Run immediately after DOM load
//   if (!updatePhoneField()) {
//     // Watch for dynamic rendering (Boost often injects elements asynchronously)
//     const observer_placeholder = new MutationObserver(() => {
//       const success = updatePhoneField();
//       if (success) observer_placeholder.disconnect(); // stop once done
//     });
//     observer_placeholder.observe(document.body, { childList: true, subtree: true });
//   }

// });
  /* ---------------------------------------------
  BOOST AI SEARCH - UPDATE CART COUNT & DRAWER
   --------------------------------------------- */
  // Intercept all fetch requests to detect cart additions
  (function() {
    // Intercept Fetch API
    var originalFetch = window.fetch;
    window.fetch = function() {
      var fetchPromise = originalFetch.apply(this, arguments);
      var url = arguments[0];
      
      // Check if this is a cart add request
      if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('cart/add') !== -1)) {
        fetchPromise.then(function(response) {
          if (response.ok) {
            // Clone response to get cart data
            response.clone().json().then(function(data) {
              // Trigger the theme's native cart update which will:
              // 1. Update cart count
              // 2. Update cart contents
              // 3. Open the drawer/popup automatically
              if (typeof Shopify !== 'undefined' && typeof Shopify.KT_getCart === 'function') {
                // Use the theme's cart update function
                Shopify.KT_getCart();
              } else {
                // Fallback: manually update count and mark for refresh
                if (data && data.item_count !== undefined) {
                  $('.cartCount').text(data.item_count);
                } else {
                  fetch('/cart.js')
                    .then(function(res) { return res.json(); })
                    .then(function(cart) {
                      $('.cartCount').text(cart.item_count);
                    });
                }
                $('.mini-cart').addClass('load');
              }
              
              // Add animation to cart icon
              $('.mini-cart .icon-count').addClass('cart-updated');
              setTimeout(function() {
                $('.mini-cart .icon-count').removeClass('cart-updated');
              }, 600);
            }).catch(function() {
              // If response parsing fails, still trigger cart update
              if (typeof Shopify !== 'undefined' && typeof Shopify.KT_getCart === 'function') {
                Shopify.KT_getCart();
              } else {
                $('.mini-cart').addClass('load');
              }
            });
          }
          return response;
        }).catch(function() {
          // Silently handle errors
        });
      }
      
      return fetchPromise;
    };
    
    // Also intercept XMLHttpRequest for older implementations
    var originalXHROpen = XMLHttpRequest.prototype.open;
    var originalXHRSend = XMLHttpRequest.prototype.send;
    
    XMLHttpRequest.prototype.open = function(method, url) {
      this._url = url;
      return originalXHROpen.apply(this, arguments);
    };
    
    XMLHttpRequest.prototype.send = function() {
      var xhr = this;
      if (xhr._url && typeof xhr._url === 'string' && xhr._url.indexOf('/cart/add') !== -1) {
        xhr.addEventListener('load', function() {
          if (xhr.status >= 200 && xhr.status < 300) {
            setTimeout(function() {
              if (typeof Shopify !== 'undefined' && typeof Shopify.KT_getCart === 'function') {
                Shopify.KT_getCart();
              }
              $('.mini-cart .icon-count').addClass('cart-updated');
              setTimeout(function() {
                $('.mini-cart .icon-count').removeClass('cart-updated');
              }, 600);
            }, 100);
          }
        });
      }
      return originalXHRSend.apply(this, arguments);
    };
  })();

  // Discount code observer - show message when code is entered
  (function() {
    var checkDiscountCode = function() {
      var discountInput = document.querySelector('#discount_code');
      var cuponMsg = document.querySelector('.cupon_msg_two');
      if (discountInput && cuponMsg) {
        if (discountInput.value !== '') {
          cuponMsg.classList.remove('d-none');
        } else {
          cuponMsg.classList.add('d-none');
        }
      }
    };

    // Check on page load
    document.addEventListener('DOMContentLoaded', checkDiscountCode);

    // Check on input change
    document.addEventListener('input', function(e) {
      if (e.target && e.target.id === 'discount_code') {
        checkDiscountCode();
      }
    });

    // MutationObserver for dynamically added #discount_code
    var observer = new MutationObserver(function(mutations) {
      var discountInput = document.querySelector('#discount_code');
      if (discountInput) {
        checkDiscountCode();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  